<template>
  <aside :class="{sidebar: true, toggled: sidebarVisible}">
    <div class="scrollbar-inner">
      <div class="user">
        <div class="user__info" data-toggle="dropdown" @click="handleShowUserDropDownMenu">
          <img class="user__img" :src="avatar_url" alt="">
          <div>
            <div class="user__name">
              {{username}}
              <el-tag type="primary" v-if="info_is_verified">已审核</el-tag>
              <el-tag type="danger" v-else>未审核</el-tag>
            </div>
            <div class="user__email">{{spname}}</div>
          </div>
        </div>

        <div :class="{'dropdown-menu': true, show: showUserDropDownMenu}">
          <!--<router-link class="dropdown-item" :to="{ name: 'SpInfo', params: {}}">我的信息</router-link>-->
          <a class="dropdown-item" href="javascript:void(0)" @click="logout_session">退出登录</a>
        </div>
      </div>

      <ul class="navigation">
        <!--<router-link tag="li" exact :to="{ name: 'Dashboard', params: {}}">-->
        <!--<a><i class="zmdi zmdi-home"></i> 工作台</a>-->
        <!--</router-link>-->
        <router-link tag="li" exact :to="{ name: 'ReportQueryInfo', params: {}}">
          <a><i class="zmdi zmdi-wrench"></i> 我要报修</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'RepairList', params: {}}">
          <a><i class="zmdi zmdi-view-list"></i> 报修列表</a>
        </router-link>
        <router-link tag="li" :to="{ name: 'UserInfo', params: {}}" class="navigation__sub">
          <a><i class="zmdi zmdi-account"></i> 我的信息</a>
        </router-link>
      </ul>
    </div>
  </aside>
</template>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import {logout} from '../../utils/auth';

  export default {
    components: {},
    data() {
      return {
        showUserDropDownMenu: false
      }
    },
    computed: {
      ...mapGetters([
        'username',
        'spname',
        'avatar',
        'sidebarVisible',
        'info_is_verified'
      ]),
      avatar_url: {
        get() {
          return this.avatar || require('../../assets/img/profile-pics/8.jpg');
        }
      }
    },
    methods: {
      ...mapActions([
        'fetchUserInfo'
      ]),
      logout_session() {
        logout();
      },
      handleShowUserDropDownMenu() {
        this.showUserDropDownMenu = true;

        let that = this;
        this.$nextTick(function () {
          $(document).on('click.usermenu', function (evt) {
            evt.stopPropagation();
            if ($(evt.target).closest('.user').length) {
              return;
            }
            that.showUserDropDownMenu = false;
            $(document).off('click.usermenu');
          });
        });
      }
    },
    beforeCreated() {
    },
    created() {
    },
    mounted() {
      this.fetchUserInfo();
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/layout/app-sidebar.vue